<template>
    <dtunes-modal :dialog="dialog" :color="color" @openModal = "dialog = true" @closeModal = "dialog = false">
    <template v-slot:button>
        <span v-if="action == 'approve'">Approve</span>
        <span v-if="action == 'decline'">Decline</span>
        <span v-if="action == 'refund'">Refund</span>
    </template>
    <template v-slot:content>
      <v-card flat class="dt-border pad-10">
        <v-card-title class="d-flex justify-center">
          <p v-if="action == 'approve'" class="text-center">Approve Transaction</p>
          <p v-if="action == 'decline'" class="text-center">Decline Transaction</p>
          <p v-if="action == 'refund'" class="text-center">Refund Transaction</p>
        </v-card-title>
        <v-card-text>
            <p>
                You are about 
                <span v-if="action == 'decline'">declining</span> 
                <span v-if="action == 'approve'">approving</span> 
                <span v-if="action == 'refund'">refunding</span> 
                this transaction. Please check the box below to confirm action
            </p>
            <v-checkbox
              v-model="agree"
              label="I agree with this action"
              color="auto"
              value="red"
              hide-details
            ></v-checkbox>
            <br>
            <label for="">Enter Reason</label>
            <v-text-field
                style="border-color: red"
                color="auto"
                outlined
                v-model="reason"
            ></v-text-field>
            <br />
            <default-button :loading="loading" :disabled='!isComplete' @click="changeStatus()">
                <span v-if="action == 'approve'">Approve Transaction</span>
                <span v-if="action == 'decline'">Decline Transaction</span>
                <span v-if="action == 'refund'">Refund Transaction</span>
            </default-button>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
// ========== IMPORT COMPONENT ==========
import DefaultButton from "@/components/Buttons/default-button.vue";
import DtunesModal from "@/components/dtunes-modal.vue";

// ============== IMPORT SERVICES ============
import { WalletService } from '@/services'

export default {
    components:{
        DefaultButton,
        DtunesModal
    },
    props:{
        details:{
            type: Object,
            required: true
        },
        action:{
            type:String,
            required : true
        }
    },
    data:() => ({
        loading : false,
        dialog:false,
        reason:'',
        agree: false,
    }),
    computed:{
        color(){
            let type;
            if(this.action == 'approve'){
                type = 'success';
            }
            else if(this.action == 'decline'){
                type = 'error';
            }
            else if(this.action == 'refund'){
                type = 'warning'
            }
            return type;
        },
        isComplete(){
            return this.agree
        }
    },
    methods:{
        async changeStatus(){
            try {
                this.loading = true;
                const data = await WalletService.changeStatus({
                    action : this.action,
                    withdrawal : this.details.id,
                    reason : this.reason
                })
                this.loading = false;
                let message;
                if(this.action == 'approve'){
                    message = 'Transaction has been approved successsfully'
                }
                else if(this.action == 'decline'){
                    message = 'Transaction decline successful'
                }
                else if(this.action == 'refund'){
                    message = 'Transaction refund successful'
                }
                this.$store.dispatch('toast', {
                    message: message,
                    variant: 'success'
                });
                console.log(data);
                this.dialog = false;
                this.$emit('closeModal')
            } catch (error) {
                this.loading = false
                console.log(error);
            }
        }
    }
}
</script>